// extracted by mini-css-extract-plugin
export var notificationHost = "_ml-0";